import React, { useEffect } from "react";
import CustomHeading from '../../../constants/CustomHeading';
import CustomSimpleTable from '../../../constants/CustomSimpleTable';
import {connect} from 'react-redux';
import {getManageUser} from '../../../redux/actions/dataAction';
import {Link} from 'react-router-dom';
const ManageUser = (props) => {

  useEffect(()=>{
    props.getManageUser();
  },[])
  console.log(props?.users?.data)
  const columns=[
    {title:'Faculty Type',field:'facility_type'},
    {title:'First Name',field:'first_name'},
    {title:'Last Name',field:'last_name'},
    {title:'Email',field:'email'},
    {title:'Phone No.',field:'phone_number'},
    {title:'Faculty Contribution',field:"Facultycontribution"}
  ]
  let arr=props?.users?.data && props?.users?.data?.map(user=>{
    return(
    {id:user.id,facility_type: user.facility_type, email: user.email, phone_number:user.phone_number,first_name:user.first_name,last_name:user.last_name,Facultycontribution:<Link>View Faculty Contribution</Link>}
    )
})
  return (
    <div className={'customContainer mb-5'}>
      <CustomHeading title="All User"/>
      <CustomSimpleTable columns={columns} data={arr} title={'All User'}/>
    </div>
  );
};
const mapActionWithProps = {
  getManageUser,
}
const mapStateWithProps = (state)=>(
  {
      users:state.data.users
  }
)

export default connect(mapStateWithProps,mapActionWithProps)(ManageUser);
